import { useState } from 'react';

import { CompanyProfileCheck } from '@/modules/companies/components/companyProfileCheck/CompanyProfileCheck';
import { useCurrentTenantQuery } from '@/modules/companies/queries/useCurrentTenantQuery';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/modules/ui/components/dialog/Dialog';

/**
 * The one-time "Is this your company?" screen at sign-in, for a self-service company nobody there has answered it for
 * (finlay-api's needsProfileCheck). Answering or skipping it keeps that for everyone at the company; closing it only
 * puts it off until the next visit.
 */
export function CompanyProfileCheckDialog() {
  const currentTenantQuery = useCurrentTenantQuery();
  const [closed, setClosed] = useState(false);
  const company = currentTenantQuery.data;

  if (
    !company?.needsProfileCheck ||
    company.onboarding?.isComplete !== true ||
    closed
  ) {
    return null;
  }

  return (
    <Dialog open onOpenChange={(open) => setClosed(!open)}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Help us get to know you better</DialogTitle>
          <DialogDescription>
            Finlay suggests what size and industry of company your jobs find
            people from, starting with your own.
          </DialogDescription>
        </DialogHeader>
        <CompanyProfileCheck
          companyId={company.id}
          signUpSize={company.onboarding.state?.companySize}
          allowSkip
          onDone={() => setClosed(true)}
        />
      </DialogContent>
    </Dialog>
  );
}
